// ============================================================
//  THEME.JS — Main JavaScript
// ============================================================

(function () {
  'use strict';

  // ---- Cart ----
  class Cart {
    static async add(variantId, quantity = 1) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      if (!response.ok) throw new Error('Failed to add to cart');
      return response.json();
    }

    static async get() {
      const response = await fetch('/cart.js');
      return response.json();
    }

    static async updateItem(line, quantity) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity }),
      });
      return response.json();
    }

    static async clear() {
      const response = await fetch('/cart/clear.js', { method: 'POST' });
      return response.json();
    }
  }

  // ---- Cart Count Bubble ----
  async function updateCartCount() {
    try {
      const cart = await Cart.get();
      const bubbles = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
      bubbles.forEach(b => { b.textContent = cart.item_count < 100 ? cart.item_count : '99+'; });
    } catch (e) {
      // silent fail
    }
  }

  // ---- Product Form: AJAX Add to Cart ----
  document.querySelectorAll('.quick-add').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const id = form.querySelector('input[name="id"]').value;
        await Cart.add(id);
        btn.textContent = '✓ Added!';
        btn.style.background = '#50b83c';
        await updateCartCount();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      } catch (err) {
        btn.textContent = 'Error — Try again';
        btn.style.background = '#de3618';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      }
    });
  });

  // ---- Sticky Header ----
  const headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper && headerWrapper.classList.contains('shopify-section-header-sticky')) {
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        headerWrapper.style.transform = 'translateY(-100%)';
      } else {
        headerWrapper.style.transform = 'translateY(0)';
      }
      lastScrollY = currentScrollY;
    }, { passive: true });

    headerWrapper.style.transition = 'transform 0.3s ease';
  }

  // ---- Mobile Menu Toggle ----
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileMenu = document.querySelector('.header__nav');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.getAttribute('aria-expanded') === 'true';
      mobileMenu.setAttribute('aria-expanded', String(!isOpen));
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  // ---- Announcement Bar ----
  const announcementClose = document.querySelector('.announcement-bar__close');
  if (announcementClose) {
    announcementClose.addEventListener('click', () => {
      const bar = document.querySelector('.announcement-bar');
      if (bar) {
        bar.style.height = bar.offsetHeight + 'px';
        bar.offsetHeight; // force reflow
        bar.style.transition = 'height 0.3s ease, opacity 0.3s ease';
        bar.style.height = '0';
        bar.style.opacity = '0';
        bar.style.overflow = 'hidden';
        sessionStorage.setItem('announcement-dismissed', 'true');
      }
    });

    if (sessionStorage.getItem('announcement-dismissed') === 'true') {
      const bar = document.querySelector('.announcement-bar');
      if (bar) bar.style.display = 'none';
    }
  }

  // ---- Image Lazy-Load Fallback ----
  if ('loading' in HTMLImageElement.prototype === false) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src || img.src;
            observer.unobserve(img);
          }
        });
      });
      images.forEach(img => observer.observe(img));
    }
  }

  // ---- Smooth Scroll ----
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ---- Init ----
  updateCartCount();

})();
